module.exports = __webpack_public_path__ + "img/EducationalGroups.14ea86c3.svg";